import { Product } from './product'
import uniqBy from 'lodash/uniqBy'

export interface Products {
  page: number
  per_page: number
  count: number
  totalItemsIncludingLevels: number
  values: Product[]
}

export const mergeProducts = (a: Products, b: Products): Products => ({
  ...a,
  values: uniqBy(a.values.concat(b.values), 'id'), //Platform API returns same products across pages in case of Tree structure which throws off the count
})
